module cr.events {
    class QuickResultsController {
        static $inject = ['eventView', 'TrackingService', '$scope', '$stateParams','$modal','$state','reportList' ];

        showHeader:boolean=true;

        constructor(private eventView, private trackingService, private $scope, private $stateParams, private $modal,$state,public reportList) {
            $scope.context="chronorace";

            //console.log("!!!!!!!!!!!!!!!!!!!!!!!! quickresultctrl: rows="+$stateParams["rows"]+"&header="+$stateParams["header"]+"&");
            
            if (angular.isDefined($stateParams.header) && $stateParams.header=='0')
            {
                this.showHeader=false;
            }
            if (reportList.length>0)
            {
                if (reportList.length==1 && reportList[0].DisplayName=="Tracking") this.showHeader=false;

                if ($state.current.name=='quickresults')
                {
                    //console.log("show header? "+this.showHeader+" / "+$state.current.name);
                    $state.go("quickresults.group",{groupId: reportList[0].Id });
                }
            }
        }
    }
    eventModule.controller('QuickResultsController', QuickResultsController);

    class QuickGroupController {
        static $inject = ['$interval','eventView', 'TrackingService', '$scope', '$stateParams','$modal','$state','reportList','reportGroup','ResultService' ];

        showHeader:boolean=true;

        rowsPerPage:number=15;
        curRepport:any=null;
        options:any={ enabled:false,search:false };
        results:any=[];
        selectedReport:any=null;

        //    <cr-table columns="results.TableDefinition.Columns" row-select="grp.SelectRow(data)" row-action="grp.RowAction(action,data)"  options="options" rows="results.Matches"></cr-table>

       /* RowAction=(action,data)=>
        {
            console.log("action: "+angular.toJson(action)+"/"+angular.toJson(data));
            switch (action)
            {
                case "video":
                case "act":
                    this.$state.go(".video",{token:data["sH_RTV"]});
                    break;

                case "select":
                    if (data["sH_Detail"] && data["sH_Detail"]!='')
                    {
                        window.location=data["sH_Detail"];
                    }
                    else if (data["sH_RTV"] && data["sH_RTV"]!='')
                    {
                        this.$state.go(".video",{token:data["sH_RTV"]});
                    }
                    break;
            }
        }*/
        /*SelectRow=(data)=>
        {
            console.log("data: "+angular.toJson(data));
        }*/


        SelectResult(result)
        {
            console.log("Select Result"+angular.toJson(result));
            switch (result.ReportType.toLowerCase()){
                case "link":
                case "url":
                        //window.location.href="https://crdev.blob.core.windows.net/files/"+result.Settings.FileName;
                    console.log(angular.toJson(result));
                    console.log("go to iframe");
                    this.$state.go("quickresults.group.url",{reportId: result.Id});
                    break;

                case "time":
                case "xml":         
                    this.$state.go("quickresults.group.report",{reportId: result.Id});
                    break;
                
                case "live":
                
                    this.$state.go("quickresults.group.ligne",{reportId: result.Id});                
                    break;

                case "file":
                    /*switch (result.Settings.FileType.toLowerCase()){
                     }*/
                    window.location.href="https://crdev.blob.core.windows.net/files/"+result.Settings.FileName;
                    break;


                default:
                     console.log("result type not handled ["+result.ReportType+"]");
                     break;
            }
        }

        GetIcon(result)
        {
            switch (result.ReportType){
                case "Link":
                    return "fa fa-external-link";

                case "File":
                    switch (result.Settings.FileType.toLowerCase()){
                        case "pdf":
                            return "fa fa-file-pdf-o";

                        case "xls":
                            return "fa fa-file-excel-o";

                        default:
                            return "fa fa-file-o";
                    }
                    break;

                default:
                    return "fa fa-chevron-right";

            }
        }


        constructor(private $interval,private eventView, private trackingService, private $scope, private $stateParams, private $modal,public $state,public reportList,public reportGroup,public resultService)
        {
            console.log("state: "+$state.current.name);
            if ($state.current.name=='quickresults.group')
            {
                if (reportGroup.Reports.length>0)
                {
                    var firstReport=reportGroup.Reports[0];
                    this.SelectResult(firstReport);
                }
            }
            /*this.curRepport=_.find(reportGroup.Reports,rpt=>(<any>rpt).ReportType=='Time');
            if (this.curRepport==null) this.curRepport=_.find(reportGroup.Reports,rpt=>(<any>rpt).ReportType=='XML');
            this.$scope.search="";
        
            console.log("quick group controller: "+$stateParams.scroll);*/                        
        }
    }

    eventModule.controller('QuickGroupController', QuickGroupController);


    class VideoController {
        static $inject = ['eventView', 'TrackingService', '$scope', '$stateParams','$modal','$state','videoReferences'];

        showHeader:boolean=true;

        constructor(private eventView, private trackingService, private $scope, private $stateParams, private $modal,$state,public videoReferences)
        {
            console.log("video: "+angular.toJson(videoReferences)+" / "+$state.current.name);
            if ($state.current.name=='quickresults.group.report.video' && videoReferences.length>0)
            {
                           
                //http://localhost:16151/angular/results.html#/quickresults/1189997998821446/group/21927/report/19052/video/RjE6NTM3Nzg4NTEgMjUgNQ?ll=155518832334
                $state.go("quickresults.group.report.video.content",{idx:0});
            }
        }
    }

    eventModule.controller('VideoController', VideoController);
  


    class VideoContentController {
        static $inject = ['eventView', 'TrackingService', '$scope', '$stateParams','$modal','$state','videoReferences','videoLink'];

        showHeader:boolean=true;

        constructor(private eventView, private trackingService, private $scope, private $stateParams, private $modal,$state,public videoReferences,public videoLink)
        {
            console.log("video content: "+angular.toJson(videoReferences)+" / "+angular.toJson(videoLink));


            $scope.player = jwplayer('video').setup({
                playlist: [{
                    title: "Finisher movie",
                    file: videoLink,
                    type: "mp4"
                }]
                , autostart: true
                , width: '100%'
                , aspectratio: '16:9'});

        }
    }

    eventModule.controller('VideoContentController', VideoContentController);


    export class QuickReportController {
        static $inject = ['$interval','eventView', 'TrackingService', '$scope', '$stateParams','$modal','$state','reportList','reportGroup','report','ResultService' ];

        showHeader:boolean=true;

        rowsPerPage:number=15;
        curRepport:any=null;
        options:any={ enabled:false,search:false };
        results:any=[];

        //    <cr-table columns="results.TableDefinition.Columns" row-select="grp.SelectRow(data)" row-action="grp.RowAction(action,data)"  options="options" rows="results.Matches"></cr-table>

        RowAction=(action,data)=>
        {
            console.log("action: "+angular.toJson(action)+"/"+angular.toJson(data));
            switch (action)
            {
                case "video":
                case "act":
                    this.$state.go(".video",{token:data["sH_RTV"]});
                    break;

                case "select":
                    if (data["sH_Detail"] && data["sH_Detail"]!='')
                    {
                        window.location=data["sH_Detail"];
                    }
                    else if (data["sH_RTV"] && data["sH_RTV"]!='')
                    {
                        this.$state.go(".video",{token:data["sH_RTV"]});
                    }
                    break;
            }

        }
        SelectRow=(data)=>
        {
            console.log("data: "+angular.toJson(data));
        }


        SetPage=(page)=>{
            this.resultService.searchReport(this.$stateParams['eventId'],this.curRepport.Id,this.$scope.search,(page-1)*this.rowsPerPage,this.rowsPerPage).then(data=>{
                this.results=data;
            });
        }

        SearchResult=(toSearch)=>{
            console.log("search: "+toSearch);
            //console.log("currepport: "+angular.toJson(this.curRepport));
            this.$scope.curPage=1;
            this.resultService.searchReport(this.$stateParams['eventId'],this.curRepport.Id,toSearch,0,this.rowsPerPage).then(data=>{
                this.results=data;
            });

        }

        constructor(private $interval,private eventView, private trackingService, private $scope, private $stateParams, private $modal,public $state,public reportList,public reportGroup,public report,public resultService)
        {
            //console.log("cool? "+angular.toJson(report));
            this.$scope.grp.selectedReport=report;

            //this.curRepport=_.find(reportGroup.Reports,rpt=>(<any>rpt).ReportType=='Time');
            this.curRepport=report;
            //if (this.curRepport==null) this.curRepport=_.find(reportGroup.Reports,rpt=>(<any>rpt).ReportType=='XML');
            this.$scope.search="";
        
            console.log("quick group controller: "+$stateParams.scroll);
            if (angular.isDefined($stateParams.header) && $stateParams.header=='0')
            {
                this.showHeader=false;
            }
            if (angular.isDefined($stateParams.rows))
            {
                this.rowsPerPage=parseInt($stateParams.rows);
            }
            if (angular.isDefined($stateParams.scroll))
            {
                var delay=parseInt($stateParams.scroll);
                if (delay<5000) delay=5000;

                console.log("scroll? "+angular.toJson(this.results.Count)+"/"+this.rowsPerPage);                    

                var timer = $interval(()=>
                {
                    this.$scope.curPage++;
                    if ((this.$scope.curPage-1)*this.rowsPerPage>=this.results.Count) this.$scope.curPage=1;
                    //console.log("lala? "+angular.toJson(this.results.Count)+"/"+this.rowsPerPage+"/"+this.$scope.curPage);  
                    this.SetPage(this.$scope.curPage);                  
                },delay);
    
                $scope.$on('$destroy', () => {
                    // Make sure that the interval is destroyed too                    
                    $interval.cancel(timer);
                });
            }
                        
            this.SearchResult("");
        }
    }
 
    export class QuickLiveLigneController 
    {
        static $inject = ['$interval','eventView', 'TrackingService', '$scope', '$stateParams','$modal','$state'
            ,'reportList','reportGroup','report','ResultService','timingConfiguration' ];

        curRepport:any=null;
        options:any={ enabled:false,search:false };
        results:any=[];
        timingGroupConfiguration:any=[];
        rowsPerPage:number=50;
        flag:number=0;
        showHeader:boolean=true;

        ToggleFlag=(flag)=>
        {
            if (this.flag.Flag==0)
            {
                this.flag=0;
                return;
            }
            //console.log("flag: "+angular.toJson(flag));
            if (this.HasFlag(flag))
            {
                this.flag=(this.flag|flag.Flag)^flag.Flag;
            } 
            else 
            {
                this.flag=this.flag|flag.Flag;
            }
            this.SetPage(1);

        }
        HasFlag=(flag)=>
        {
            if (flag.Flag==0)
            {
                return this.flag==0;
            }
            return (this.flag&flag.Flag)==flag.Flag;
        }


        RowAction=(action,data)=>
        {
            console.log("action: "+angular.toJson(action)+"/"+angular.toJson(data));
            switch (action)
            {
                case "video":
                case "act":
                    this.$state.go(".video",{token:data["sH_RTV"]});
                    break;

                case "select":
                    if (data["sH_Detail"] && data["sH_Detail"]!='')
                    {
                        window.location=data["sH_Detail"];
                    }
                    else if (data["sH_RTV"] && data["sH_RTV"]!='')
                    {
                        this.$state.go(".video",{token:data["sH_RTV"]});
                    }
                    break;
            }
        }

        SelectRow=(data)=>
        {
            console.log("data: "+angular.toJson(data));
        }


        SetPage=(page)=>{
            
            this.$scope.curPage=page;
            this.resultService.overview(this.$stateParams['eventId'],this.report.Settings.Groupe,this.flag,this.$scope.search,(page-1)*this.rowsPerPage,this.rowsPerPage).then(data=>{
                this.results=data;
            });
        }

        //overview(eventId:string,groupId:string,mask:string,search:string,from:number,maxEntries:number): angular.IPromise<cr.entity.DynamicTable>

        SearchResult=(toSearch)=>{
            console.log("search: "+toSearch);
            //console.log("currepport: "+angular.toJson(this.curRepport));
            this.$scope.curPage=1;
            this.resultService.overview(this.$stateParams['eventId'],this.report.Settings.Groupe,this.flag,toSearch,0,this.rowsPerPage).then(data=>{
                this.results=data;
            });

        }

        constructor(private $interval,private eventView, private trackingService, private $scope, private $stateParams, private $modal
            ,public $state,public reportList,public reportGroup,public report,public resultService
            ,public timingConfiguration)
        {
            console.log("report: "+angular.toJson(report));

            this.curRepport=report;        
            this.timingGroupConfiguration= _.find(timingConfiguration.ResultGroups,g=>(<any>g).GroupId==report.Settings.Groupe);

            //console.log("cool? "+angular.toJson(report));
            this.$scope.grp.selectedReport=report;

            //if (this.curRepport==null) this.curRepport=_.find(reportGroup.Reports,rpt=>(<any>rpt).ReportType=='XML');
            this.$scope.search="";
        
                        
            this.SearchResult("");
        }
    }
}
